import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { fetchOverview } from '@/slices/bookkeeperSlice';
import { fetchClusterDetailByName } from '@/slices/clusterSlice';
import Body from './Body';
import Summary from './Summary';

function List({ fetchOverview, fetchClusterDetailByName }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');
  useEffect(() => {
    if (clusterName) {
      fetchOverview(clusterName);
      fetchClusterDetailByName(clusterName);
    }
  }, [clusterName, fetchOverview, fetchClusterDetailByName]);

  return (
    <Root>
      <Summary />
      <Body clusterName={clusterName} />
    </Root>
  );
}

export default connect(null, {
  fetchOverview,
  fetchClusterDetailByName,
})(List);

const Root = styled.div`
  padding-right: 20px;
`;
